import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import GifPreview from 'shared/components/gif-preview'
import { getUrl } from 'shared/util/gif-extract'
import ListItemInfo from './list-item-info'
import css, { gifWidth, gifHeight } from './list-item.css'

export default class extends Component {
    static propTypes = {
        gif: PropTypes.object,
        lastTimeChange: PropTypes.number,
        isInPreloadRange: PropTypes.bool,
        isInPriorityRange: PropTypes.bool,
        isLive: PropTypes.bool,
        onSocialClick: PropTypes.func,
        autoPlay: PropTypes.bool,
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isInPriorityRange !== this.props.isInPriorityRange) {
            return true
        }
        if (nextProps.isInPreloadRange !== this.props.isInPreloadRange) {
            return true
        }
        if (nextProps.lastTimeChange !== this.props.lastTimeChange) {
            return true
        }
        if (nextProps.isLive !== this.props.isLive) {
            return true
        }
        if (nextProps.autoPlay !== this.props.autoPlay) {
            return true
        }
        return false
    }

    render() {
        const { autoPlay, gif, isInPreloadRange, isInPriorityRange, isLive, onSocialClick } = this.props
        const { create_datetime, url, user, tags, is_sticker } = gif

        return (
            <li className={css.item}>
                <div className={css.gif}>
                    <GifPreview
                        still={getUrl(gif, 'fixed_height_still')}
                        animated={getUrl(gif, 'fixed_height')}
                        isInPreloadRange={isInPreloadRange}
                        isInPriorityRange={isInPriorityRange}
                        autoPlay={autoPlay}
                        url={url}
                        isHidden={false}
                        user={user}
                        tags={tags}
                        isSticker={is_sticker}
                        width={parseInt(gifWidth, 10)}
                        height={parseInt(gifHeight, 10)}
                        shouldUseLinkFallback={true}
                    />
                </div>
                <ListItemInfo
                    gif={gif}
                    date={create_datetime}
                    isLive={isLive}
                    onSocialClick={type => onSocialClick(gif.id, type)}
                />
            </li>
        )
    }
}
